import React from "react";
import PropTypes from 'prop-types'
import Image from "../Image";

const LeftSidedImageCopyItem = (props) => {
  const { description,descriptionContent, image, title } = props;
  return (
    <div className="row mb-75">
      <div className="col-md-12 col-lg-6 mobile-last">
        <Image className="w-100" image={image}/>
      </div>
      <div className="col-md-12 col-lg-6">
        <div className="about-text">
          <h3>{title}</h3>
        {
          (Array.isArray(description) && (description.length > 0 ) && description.map((item, i)=>(
            <p key={i}>{item}</p>
          )))
        }
        {descriptionContent}
          
        </div>
      </div>
    </div>
  );
};

LeftSidedImageCopyItem.propTypes = {
  // description : PropTypes.arrayOf,
  descriptionContent : PropTypes.node,
  image : PropTypes.string,
  title : PropTypes.string
}

export default LeftSidedImageCopyItem;
